import React from 'react';
import { useSelector } from 'react-redux';
import { deleteMeetingRoom } from '../../../../actions/meetingRoom.js';
import RightPanel from './rightPanel';
import CenterPanel from './centerPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

export default function ContentNotifyRoomParticipant(props) {
  const notifyRoomParticipantsForm = useSelector((state) =>
    state.waitingAreaReducer.notifyRoomParticipantsForm
      ? state.waitingAreaReducer.notifyRoomParticipantsForm
      : undefined
  );

  let showModal = props.showNotifyRoomParticipantModal;
  // Remove the space after caller's name is it has, for better UI display
  let callerName = props.participantRoomData.mainParticipant.name;
  if (/ $/.test(callerName)) {
    callerName = callerName.slice(0, -1);
  }
  return (
    <Modal show={showModal} hideWhenClickAway={true} className={'add-to-call'}>
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.NotifyParticipant}
        title={APP.LANGUAGE.NotifyCaller.Title.replace('##caller##', callerName)}
        subtitle={''}
      />
      <div className="content">
        <div className="main-ui-container meeting-room-create-update">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanel
                  participantRoomData={props.participantRoomData}
                  notifyRoomParticipants={notifyRoomParticipantsForm}
                />
              </div>
            </div>
            <CenterPanel
              participantRoomData={props.participantRoomData}
              notifyRoomParticipants={notifyRoomParticipantsForm}
            />
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <RightPanel
                participantRoomData={props.participantRoomData}
                notifyRoomParticipants={notifyRoomParticipantsForm}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
